export enum CustomerType {
  PRIVATE = 'PRIVATE',
  ORGANISATION = 'ORGANISATION',
  MUNICIPAL = 'MUNICIPAL',
}
